import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';
import { Box, IconButton, InputAdornment, MenuItem, TextField, Typography } from '@mui/material';

import { helperSx, inputSx, labelSx, wideInputSx } from './styles';

interface CredFieldProps {
  label: string;
  name: string;
  value?: string;
  onChange: (name: string, value: string) => void;
  isPassword?: boolean;
  helperText?: string;
  showPassToggle?: boolean;
  showPass?: boolean;
  toggleShowPass?: () => void;
  select?: boolean;
  options?: Array<string | { label: string; value: string }>;
  disabled?: boolean;
  wide?: boolean;
}

/** Reusable credential field */
export const CredField = ({
  label,
  name,
  value,
  onChange,
  isPassword = false,
  helperText,
  showPassToggle = false,
  showPass = false,
  toggleShowPass,
  select = false,
  options = [],
  disabled = false,
  wide = false,
}: CredFieldProps) => (
  <Box sx={{ mb: 1 }}>
    <Typography sx={labelSx}>{label}</Typography>
    {select ? (
      <TextField
        select
        name={name}
        value={value || ''}
        onChange={(e) => onChange(name, e.target.value)}
        size="small"
        fullWidth
        disabled={disabled}
        sx={wide ? wideInputSx : inputSx}
      >
        <MenuItem value="">
          <em>Select...</em>
        </MenuItem>
        {options.map((opt) => {
          const optLabel = typeof opt === 'string' ? opt : opt.label;
          const optValue = typeof opt === 'string' ? opt : opt.value;
          return (
            <MenuItem key={optValue} value={optValue}>
              {optLabel}
            </MenuItem>
          );
        })}
      </TextField>
    ) : (
      <TextField
        name={name}
        type={isPassword && !showPass ? 'password' : 'text'}
        value={value || ''}
        onChange={(e) => onChange(name, e.target.value)}
        size="small"
        fullWidth
        disabled={disabled}
        sx={wide ? wideInputSx : inputSx}
        slotProps={{
          input: showPassToggle
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={toggleShowPass} edge="end">
                      {showPass ? (
                        <VisibilityOffIcon sx={{ fontSize: 18 }} />
                      ) : (
                        <VisibilityIcon sx={{ fontSize: 18 }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : undefined,
        }}
      />
    )}
    {helperText && <Typography sx={helperSx}>{helperText}</Typography>}
  </Box>
);
